export const REQUEST_PUBLISH_PROJECT = 'REQUEST_PUBLISH_PROJECT';
export const PUBLISH_PROJECT_RECEIVED = 'PUBLISH_PROJECT_RECEIVED';